export default __webpack_public_path__ + "static/media/2W.b13c1bd4.svg";